// extracted by mini-css-extract-plugin
export default {"socialLink":"styles_socialLink__WKjnZ"};